// Accounting Income Types Vuex

import state from './expenseStates.js'
import * as getters from './expenseGetters.js'
import * as mutations from './expenseMutations.js'
import * as actions from './expenseActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
